// import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import PropTypes from "prop-types"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { IS_PORTAL, jewlr_t, IS_GE_CHECKOUT } from "helpers/application"
import { cn } from "styles/utils"

const ShipMethod = ({ className = "", ...props }) => (
  <p
    className={cn(
      "text-14 tablet:whitespace-nowrap mb-2 font-medium text-black",
      className
    )}
    {...props}
  />
)

const LineItemShipping = ({ item }) => {
  // const forHer = item.product_gender === "female"
  const is_ge_checkout = IS_GE_CHECKOUT()
  return (
    <div className="tablet:mt-12 mb-16 mt-14 text-right">
      {item.holiday_availability && (
        <Media greaterThanOrEqual="tablet">
          <div className="mb-8 flex items-center justify-end">
            <FontAwesomeIcon className="text-sale text-14 mr-5" icon={faGift} />
            <ShipMethod className="text-sale text-16 tracking-tigher mb-0 font-semibold">
              Arrives Before{" "}
              {sl.config.guaranteed_holiday_alias ||
                sl.config.guaranteed_holiday}
              {/* Arrives{" "}
          {new Date(item.min_delivery_date).getDate() ===
          new Date(sl.config.guaranteed_receive_date).getDate()
            ? "By"
            : "Before"}{" "}
          {sl.config.guaranteed_holiday} */}
            </ShipMethod>
          </div>
        </Media>
      )}
      {!is_ge_checkout &&
      item.delivery_dates &&
      item.delivery_dates.length > 0 ? (
        item.delivery_dates.map((d) => (
          <ShipMethod
            className={cn(
              d.type.includes(IS_PORTAL ? "Standard" : "FREE")
                ? "text-black"
                : "text-green-darker"
            )}
            data-cy={`itemShipping-${d.type}`}
            key={`itemShipping-${d.type}`}
          >
            <strong>{d.type}</strong>{" "}
            {!d.date_range?.length > 0 && (
              <span className="tablet:not-italic italic">{d.date}</span>
            )}
            {d.date_range?.length > 0 && (
              <>
                <span className="tablet:not-italic italic">
                  {d.date_range[0]}
                </span>{" "}
                to{" "}
                <span className="tablet:not-italic italic">
                  {d.date_range[1]}
                </span>
              </>
            )}
          </ShipMethod>
        ))
      ) : item.delivery_date_range ? (
        <ShipMethod>
          {IS_PORTAL() ? "Standard" : "Free"} {jewlr_t("terms.Shipping")}{" "}
          <span className="tablet:not-italic italic">
            {item.delivery_date_range[0]}-{item.delivery_date_range[1]}
          </span>
        </ShipMethod>
      ) : (
        <ShipMethod>
          Ships by{" "}
          <span className="tablet:not-italic italic">{item.est_ship_date}</span>
        </ShipMethod>
      )}
    </div>
  )
}

LineItemShipping.propTypes = {
  item: PropTypes.object,
}
ShipMethod.propTypes = {
  className: PropTypes.string,
}
export default LineItemShipping
